export default __webpack_public_path__ + "static/media/customer.0a489cef.svg";